import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE, STORE_STORAGE } from '../../_config'


export function* getReviewSummary(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.REVIEW.GET_REVIEW_SUMMARY, data, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getReviewList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.REVIEW.REVIEW_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getRatingSummary(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RATING.RATING_SUMMARY, data, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}
